class ApiService {
  constructor() {
    // 新的API地址和认证密钥
    this.API_URL = 'https://ark.cn-beijing.volces.com/api/v3/chat/completions';
    this.API_KEY = '39c81dc3-a7ba-4e8c-8d32-07171419a67e'; // 实际项目中应从环境变量获取
    this.controller = null;
  }

  async streamChat(messages) {
    try {
      // 创建新的 AbortController
      this.controller = new AbortController();
      
      const response = await fetch(this.API_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          messages: messages,
          model: "deepseek-r1-250528", // 新的模型名称
          stream: true
        }),
        signal: this.controller.signal
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      return {
        stream: reader,
        stop: () => {
          if (this.controller) {
            this.controller.abort();
            this.controller = null;
          }
        }
      };
    } catch (error) {
      console.error('API error:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService();

// 添加日志记录函数
export const logChat = async (question, response) => {
  try {
    const logData = {
      timestamp: new Date().toISOString(),
      question: question,
      response: response,
      user_agent: navigator.userAgent,
      platform: navigator.platform
    };

    const result = await fetch('https://sk.yirenyian.com/api/open/deepseeklog/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(logData)
    });

    if (!result.ok) {
      throw new Error(`HTTP error! status: ${result.status}`);
    }
  } catch (error) {
    console.error('Failed to log chat:', error);
    // 失败不影响主流程
  }
}; 